(() => {
  if (window.gdProductDetailsReady) return;
  window.gdProductDetailsReady = true;
  const openers = new WeakMap();
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-gd-size-guide-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.gdSizeGuideOpen);
      if (!(dialog instanceof HTMLDialogElement)) return;
      openers.set(dialog, opener);
      dialog.showModal();
      dialog.addEventListener('close', () => openers.get(dialog)?.focus(), { once: true });
      return;
    }
    const closer = event.target.closest('[data-gd-size-guide-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.matches('dialog.gd-size-guide')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('change', event => {
    const input = event.target.closest('.gd-product-page variant-selects input[type="radio"]');
    if (!input) return;
    const label = input.closest('fieldset')?.querySelector('[data-gd-selected-option]');
    if (label) label.textContent = input.value;
  });
})();
